import React from 'react'
import Button from '@mui/material/Button';
import { connect } from 'react-redux'
import setImageAction from '../../redux/actions/createReferenceActions/actionImage';
import setCountryErrAction from '../../redux/actions/createReferenceActions/actionCountryErr';
import setProvinceErrAction from '../../redux/actions/createReferenceActions/actionProvinceErr';
import setCityErrAction from '../../redux/actions/createReferenceActions/actionCityErr';
import setZipErrAction from '../../redux/actions/createReferenceActions/actionZipErr';
import Dialog from '@mui/material/Dialog';
import { Alert, AlertTitle } from '@mui/material';
import setErrorRequiredProdAction from '../../redux/actions/createReferenceActions/actionErrorRequiredProd';
import setImageUploadErrorAction from '../../redux/actions/createReferenceActions/actionImageUploadError';
import setFoeErrorAction from '../../redux/actions/createReferenceActions/actionFoeError';
import setTitleErrorAction from '../../redux/actions/createReferenceActions/actionTitleError';
import setDescriptionErrorAction from '../../redux/actions/createReferenceActions/actionDescriptionError';
import { withTranslation } from 'react-i18next';

class SubmintButton extends React.Component {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);

        this.props.setCountryErrFunction(false);
        this.props.setProvinceErrFunction(false);
        this.props.setCityErrFunction(false);
        this.props.setZipErrFunction(false);
        this.props.setErrorRequiredProdFunction(false);
        this.props.setImageUploadErrorFunction(false);
        this.props.setFoeErrorFunction(false);
        this.props.setTitleErrorFunction(false);
        this.props.setDescriptionErrorFunction(false);

        
        // imageUploadError ammount of pictures <=10 see also ImageLoader.js
        // uploadError error for data or images upload to server
        this.state = {
            image: '', open: false, checked: false, imageUploadError: false, uploadError: false,
            countryError: true, provinceError: true, cityError: true, zipError: true, errorRequiredProd: true,
            foeError: true, titleError: true, referenceDataBaseId: '', LongLatError: true, descriptionError: true
        }
    }

    // SubmitButton change handler
    handleClick() {
        // Check and set country error
        if (this.props.country !== undefined && this.props.country !== 'defaultCountry' && this.props.country !== '') {
            this.setState({ countryError: false }, () => {
                this.props.setCountryErrFunction(this.state.countryError);
            });
        } else {
            this.setState({ countryError: true }, () => {
                this.props.setCountryErrFunction(this.state.countryError)
            });
        }
        if (this.props.longitude !== undefined && this.props.longitude !== '' && this.props.latitude !== undefined && this.props.latitude !== '') {
            this.setState({ LongLatError: false });
        } else {
            this.setState({ LongLatError: true });
        }

        // Check and set province error
        if (this.props.province !== undefined && this.props.province !== 'defaultProvince' && this.props.province !== '') {
            this.setState({ provinceError: false }, () => {
                this.props.setProvinceErrFunction(this.state.provinceError);
            });
        } else {
            this.setState({ provinceError: true }, () => {
                this.props.setProvinceErrFunction(this.state.provinceError)
            });
        }

        // Check and set city error
        if (this.props.city !== undefined && this.props.city !== 'defaultCity' && this.props.city !== '') {
            this.setState({ cityError: false }, () => {
                this.props.setCityErrFunction(this.state.cityError);
            });
        } else {
            this.setState({ cityError: true }, () => {
                this.props.setCityErrFunction(this.state.cityError)
            });
        }

        // Check and set zip error
        if (this.props.zip !== undefined && this.props.zip !== 'defaultZip' && this.props.zip !== '') {
            this.setState({ zipError: false }, () => {
                this.props.setZipErrFunction(this.state.zipError);
            });
        } else {
            this.setState({ zipError: true }, () => {
                this.props.setZipErrFunction(this.state.zipError)
            });
        }
        // Check amount of products => if < 1 = error
        if (this.props.product.length !== 0 && this.props.product !== 'defaultProduct' && this.props.product !== '') {
            this.setState({ errorRequiredProd: false }, () => {
                this.props.setErrorRequiredProdFunction(this.state.errorRequiredProd);
            })
        } else {
            this.setState({ errorRequiredProd: true }, () => {
                this.props.setErrorRequiredProdFunction(this.state.errorRequiredProd);
            })
        }

        // Check amount of images max 10, min 1
        if (this.props.image.length < 11 && this.props.image.length >= 1) {
            this.setState({ imageUploadError: false }, () => {
                this.props.setImageUploadErrorFunction(this.state.imageUploadError);
            });
        } else {
            this.setState({ imageUploadError: true }, () => {
                this.props.setImageUploadErrorFunction(this.state.imageUploadError);
            });

        }
        // Check FOE input
        if (this.props.foe !== undefined && this.props.foe !== 'defaultFOE' && this.props.foe !== '') {
            this.setState({ foeError: false }, () => {
                this.props.setFoeErrorFunction(this.state.foeError);
            });
        } else {
            this.setState({ foeError: true }, () => {
                this.props.setFoeErrorFunction(this.state.foeError);
            });

        }
        // Check Title input
        if (this.props.title !== '' && this.props.title !== 'defaultTitle') {
            this.setState({ titleError: false }, () => {
                this.props.setTitleErrorFunction(this.state.titleError);
            });
        } else {
            this.setState({ titleError: true }, () => {
                this.props.setTitleErrorFunction(this.state.titleError);
            });

        }
        // Check Description input
        if (this.props.description !== '' && this.props.description !== 'defaultDesription') {
            this.setState({ descriptionError: false }, () => {
                this.props.setDescriptionErrorFunction(this.state.descriptionError);
            });
        } else {
            this.setState({ descriptionError: true }, () => {
                this.props.setDescriptionErrorFunction(this.state.descriptionError);
            });

        }
        // Open Dialog window (error/sucess) then upload data and images
        this.setState({ open: true }, () => {

            if (this.state.countryError === false && this.state.provinceError === false
                && this.state.LongLatError === false && this.state.cityError === false && this.state.zipError === false && this.state.errorRequiredProd === false
                && this.state.imageUploadError === false && this.state.foeError === false && this.state.titleError === false && this.state.descriptionError === false) {
                this.uploadData();

            } else {
                console.log('Upload Error -> SubmitButton')

            }
        });
    }

    // Close sucess or error dialog
    handleCloseDialog = () => {
            this.setState({ open: false, uploadError: false });
    };


    // get Images from redux and upload on server
    async handleImages(referenceDataBaseId) {

        const formData = new FormData();
        // iterate each image in state, append on formData
        if (this.props.image !== undefined) {
            for (let x = 0; x < this.props.image.length; x++) {
                let imageName = localStorage.getItem('user_id') + '&' + referenceDataBaseId;
                formData.append('file', this.props.image[x], imageName)
                formData.append("name", localStorage.getItem('user_id'))
            }

            // limit images for upload
            if (this.props.image.length < 11 && this.props.image.length >= 1) {

                await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/createRef/upload/img`, {
                    method: 'POST',
                    body: formData,
                }).then(res => { // then print response status
                    if (res.status === 200) {
                        console.log('image upload sucess')
                        // console.log(res.statusText) // OK
                        this.props.setImageFunction(this.state.image);
                        this.setState({ uploadError: false }, () => {
                            window.location.href = '/home'
                        });
                        // setTimeout(() => window.location.href = '/home', 1000)
                    } else {
                        this.setState({ uploadError: true })
                    }
                }).catch((err) => {
                    if (err) {
                        this.setState({ uploadError: true })
                    }
                })
            }
        }
    }

    async uploadData() {

        await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/createRef/upload/data`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('jwToken')}`
            },
            body: JSON.stringify({
                title: this.props.title,
                country: this.props.country,
                province: this.props.province,
                city: this.props.city,
                zip: this.props.zip,
                street: this.props.street,
                product: this.props.product,
                dateFrom: this.props.dateFrom,
                dateTo: this.props.dateTo,
                foe: this.props.foe,
                description: this.props.description,
                longDescription: this.props.longDescription,
                commentCon: this.props.commentCon,
                commentPlaner: this.props.commentPlaner,
                commentOwner: this.props.commentOwner,
                externalRelease: this.props.externalRelease,
                contestRelease: this.props.contestRelease,
                longitude: this.props.longitude,
                latitude: this.props.latitude,
                role_id: localStorage.getItem('role_id'),
                user_id: localStorage.getItem('user_id'),
                firstname: localStorage.getItem('firstname'),
                lastname: localStorage.getItem('lastname'),
                firm: localStorage.getItem('firm'),
                language: localStorage.getItem('language')
            })
        }).then(res => { 
            // then print response status
            // console.log(res.statusText) // OK
            console.log(res)
            console.log(res.status)
            if (res.status === 200) {
                res.json().then(data => {
                    this.setState({ uploadError: false, referenceDataBaseId: data.data }, () => {
                        console.log('data upload sucess')
                        this.handleImages(this.state.referenceDataBaseId);
                    });
                })
            } else {
                // if connection to node server or mysql lost
                this.setState({uploadError: true})
            }

        }).catch( (err) => {
            this.setState({uploadError: true})
            console.log(err) }
            )
    }

    render() {
        
        const { t } = this.props;

        return (
            <div>
                <Button onClick={this.handleClick} style={{ width: 300, margin: 10, backgroundColor: 'rgba(19, 174, 236, 0.54)' }} variant="contained" color="primary" size="large">
                    {t("create_ref.submit_button_submit")}
                </Button>
                <Dialog onClose={this.handleCloseDialog} aria-labelledby="simple-dialog-title" open={this.state.open}>
                    {this.state.countryError || this.state.cityError || this.state.provinceError || this.state.zipError || this.state.errorRequiredProd
                        || this.state.imageUploadError || this.state.foeError || this.state.titleError || this.state.descriptionError ? (
                            <Alert severity="error">
                                <AlertTitle>Error</AlertTitle>
                                {t("create_ref.submit_button_error_1")}
                            </Alert>) : this.state.uploadError || this.state.LongLatError ? (
                                <Alert severity="error">
                                    <AlertTitle>Error</AlertTitle>
                                        {t("create_ref.submit_button_error_2")}
                                </Alert>
                            ) : !this.state.uploadError ? (
                                <Alert severity="success">
                                    <AlertTitle>Success</AlertTitle>
                                        {t("create_ref.submit_button_error_3")}
                                </Alert>
                            ) : (null)
                    }
                </Dialog>
            </div >
        )
    }
}

// Get props from Redux store
function mapStateToProps(state) {
    return {
        title: state.createRefState.title,
        country: state.createRefState.country,
        province: state.createRefState.province,
        city: state.createRefState.city,
        zip: state.createRefState.zip,
        street: state.createRefState.street,
        product: state.createRefState.product,
        dateFrom: state.createRefState.dateFrom,
        dateTo: state.createRefState.dateTo,
        image: state.createRefState.image,
        foe: state.createRefState.foe,
        description: state.createRefState.description,
        longDescription: state.createRefState.longDescription,
        commentCon: state.createRefState.commentCon,
        commentPlaner: state.createRefState.commentPlaner,
        commentOwner: state.createRefState.commentOwner,
        externalRelease: state.createRefState.externalRelease,
        contestRelease: state.createRefState.contestRelease,
        countryError: state.createRefState.countryError,
        provinceError: state.createRefState.provinceError,
        zipError: state.createRefState.zipError,
        cityError: state.createRefState.cityError,
        longitude: state.createRefState.longitude,
        latitude: state.createRefState.latitude
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setImageFunction: image => {
            dispatch(setImageAction(image));
        }, setCountryErrFunction: countryError => {
            dispatch(setCountryErrAction(countryError));
        }, setProvinceErrFunction: provinceError => {
            dispatch(setProvinceErrAction(provinceError));
        }, setCityErrFunction: cityError => {
            dispatch(setCityErrAction(cityError));
        }, setZipErrFunction: zipError => {
            dispatch(setZipErrAction(zipError));
        }, setErrorRequiredProdFunction: errorRequiredProd => {
            dispatch(setErrorRequiredProdAction(errorRequiredProd))
        }, setImageUploadErrorFunction: imageUploadError => {
            dispatch(setImageUploadErrorAction(imageUploadError))
        }, setFoeErrorFunction: foeError => {
            dispatch(setFoeErrorAction(foeError))
        }, setTitleErrorFunction: titleError => {
            dispatch(setTitleErrorAction(titleError))
        }, setDescriptionErrorFunction: descriptionError => {
            dispatch(setDescriptionErrorAction(descriptionError))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SubmintButton));
